import PuzzleRemoteListAbstract from './PuzzleRemoteListAbstract';
import { Position } from '../../../dispatcher/Types';
import { isFunction, get } from 'lodash';
import {
  PUZZLE_REMOTE_LIST_PROPS,
  PUZZLE_REMOTE_LIST_ABSTRACT_STATE
} from './Types';
import { getTextSearchMethod } from '../../../utility';

class PuzzleRemoteList extends PuzzleRemoteListAbstract<PUZZLE_REMOTE_LIST_PROPS> {
  private allData: any[] = [];
  private virtualizationMoreThen: number = 100;

  constructor(props) {
    super(props);
    this.vs.PageChange = this.onPageChange;
  }

  /**
   * @inheritDoc
   */
  moduleDidMount() {
    super.moduleDidMount();
    const { requestConfig } = this.props;
    const { url, method, params, headers } = requestConfig;
    this.dispatch('initialMenuLoadData', Position.end, {
      menuModuleId: this.moduleId,
      menuModuleName: this.moduleName,
      url,
      method,
      params,
      headers
    });
  }

  /**
   * @inheritDoc
   */
  componentDidUpdate(prevProps: PUZZLE_REMOTE_LIST_PROPS, prevState: PUZZLE_REMOTE_LIST_ABSTRACT_STATE) {
    super.componentDidUpdate(prevProps, prevState);
    if (prevProps.listSearch !== this.props.listSearch) {
      this.searchData(this.props.listSearch);
    }
  }

  /**
   * Parses data
   * @param data
   */
  parseData = (data) => {
    const {
      dataItemKey = '',
      textField = '',
      parseData = undefined
    } = this.props;
    let parsedData;

    if (isFunction(parseData)) {
      parsedData = parseData(data);
    } else {
      parsedData = [...data];
    }

    parsedData = parsedData.map((item, index) => ({
      _index: index,
      _populated: true,
      name: get(item, textField) || item,
      value: get(item, dataItemKey) || item
    }));

    return parsedData;
  }

  /**
   * Loads data
   * @param dataCache
   * @param isNoFirstLoad
   */
  loadData = (dataCache, isNoFirstLoad?) => {
    const { pageSize } = this.state;
    if (!isNoFirstLoad) {
      this.allData = [...dataCache];
    }
    const total = dataCache.length;
    if (total > this.virtualizationMoreThen) {
      this.setState({
        data: dataCache.slice(0, pageSize),
        dataCache: [...dataCache],
        total,
        vsEnabled: true
      });
    } else {
      this.setState({
        data: dataCache.slice(0, total),
        dataCache: [...dataCache],
        total,
        vsEnabled: false
      });
    }
  }

  /**
   * Searches data by listSearch param
   * @param listSearch
   */
  private searchData = (listSearch) => {
    const { searchType } = this.props;
    const searchFunction = getTextSearchMethod(searchType);
    const dataCache = this.allData.filter(item => item.name.toLowerCase()[searchFunction](listSearch.toLowerCase()));
    this.loadData(dataCache, true);
  }

  /**
   * Get data for current page
   * @param {any} event
   */
  onPageChange = (event: any) => {
    const { skip } = event.page ?? event;
    const { dataCache, pageSize } = this.state;
    this.setState({
      skip,
      data: dataCache.slice(skip, skip + pageSize)
    });
  }
}

export default PuzzleRemoteList;
